import { ExplanationContentJsonModel } from '../../content/explanation-content.json.model';

export namespace ExplanationContentActions {
  export class Add {
    static readonly type = getActionName('Add ExplanationContent');
    constructor(readonly payload: ExplanationContentJsonModel) {}
  }

  export class AddRaw {
    static readonly type = getActionName('Add Raw');
    constructor(readonly payload: ExplanationContentJsonModel) {}
  }

  export class Edit {
    static readonly type = getActionName('Edit');
    constructor(readonly payload: ExplanationContentJsonModel) {}
  }

  export class EditRaw {
    static readonly type = getActionName('Edit Raw');
    constructor(readonly payload: ExplanationContentJsonModel) {}
  }

  export class Delete {
    static readonly type = getActionName('Delete');
    constructor(readonly payload: ExplanationContentJsonModel) {}
  }

  export class Fetch {
    static readonly type = getActionName('Fetch');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch success');
    constructor(readonly payload: ExplanationContentJsonModel[]) {}
  }

  export class FetchOne {
    static readonly type = getActionName('Fetch One');
    constructor(public id: string) {}
  }

  export class FetchOneSuccess {
    static readonly type = getActionName('Fetch One Success');
    constructor(public payload: ExplanationContentJsonModel) {}
  }

  export class FetchAppend {
    static readonly type = getActionName('Fetch Append');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchSuccessAppend {
    static readonly type = getActionName('Fetch Append Success');
    constructor(readonly payload: ExplanationContentJsonModel[]) {}
  }

  function getActionName(type: string) {
    return `[ExplanationContent] ${type}`;
  }
}
